//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: "DeviceInfo",
  props: {
    background: {
      type: String,
      default: '#43d841'
    },
    type: {
      type: String,
      default: ""
    },
    device: {
      type: Object,
      default: function () {
        return {};
      }
    },
    index: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {}
  },
  methods: {
    change() {
      this.$emit("chose", this.index)
    },
    smallbox(data) {
      this.$router.push({name: 'smallbox', params: {order: data}})
    },
    forward(data) {
      this.$router.push({name: 'Devicedetails', params: {'order': data}})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/devices/DeviceInfo.vue